import Vue from "vue";
import ResourceService from "./resource.service";

class TripRatingService extends ResourceService {
  static get resource() {
    return "trip-ratings";
  }

  static getStatus(id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`trip-ratings/status/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default TripRatingService;
